import { normalizeTime } from 'libs/dateUtils'
import { ALL_DAY } from './configs'
import * as R from 'ramda'
import { usePlace } from 'commons/usePlace'
import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { DO_NOT_RETYE, CUSTOM } from './configs'

export const initialValuesForm = (initial) => {
  const isDonotRetry =
    R.isNil(initial.retryTimesCount) &&
    R.isNil(initial.retryDurationCount) &&
    R.isNil(initial.retryDurationUnit)
  const initialValues = {
    selectedRetry: isDonotRetry ? DO_NOT_RETYE : CUSTOM,
    retryTimesCount: initial.retryTimesCount ?? 2,
    retryDurationCount: initial.retryDurationCount ?? 1,
    retryDurationUnit: initial.retryDurationUnit ?? 'hour',

    callableInformationTimeWindowStart:
      initial.callableInformationTimeWindowStart ?? ALL_DAY,
    callableInformationTimeWindowEnd:
      initial.callableInformationTimeWindowEnd ?? ALL_DAY,

    callableImportantTimeWindowStart:
      initial.callableImportantTimeWindowStart ?? ALL_DAY,
    callableImportantTimeWindowEnd:
      initial.callableImportantTimeWindowEnd ?? ALL_DAY,

    callableUrgentTimeWindowStart:
      initial.callableUrgentTimeWindowStart ?? ALL_DAY,
    callableUrgentTimeWindowEnd: initial.callableUrgentTimeWindowEnd ?? ALL_DAY,

    callableEmergencyTimeWindowStart:
      initial.callableEmergencyTimeWindowStart ?? ALL_DAY,
    callableEmergencyTimeWindowEnd:
      initial.callableEmergencyTimeWindowEnd ?? ALL_DAY,
  }
  return initialValues
}

export const useAutomatedCallSetting = (initial, onSuccess) => {
  const dispatchs = useDispatch()
  const { formatMessage } = useIntl()
  const place = usePlace()

  const errorRetry = formatMessage({
    id: 'manageChannels.retryOption.error',
  })

  const validationForm = () => {
    return Yup.object().shape({
      retryDurationCount: Yup.number()
        .min(1, errorRetry)
        .max(100, errorRetry)
        .required(errorRetry),
      retryTimesCount: Yup.number()
        .min(1, errorRetry)
        .max(100, errorRetry)
        .required(errorRetry),
    })
  }

  const submit = (values) => {
    let payload = values
    if (values.selectedRetry === DO_NOT_RETYE) {
      payload = {
        ...payload,
        retryTimesCount: null,
        retryDurationCount: null,
        retryDurationUnit: null,
      }
    }
    Object.entries(payload).forEach(([key, value], index) => {
      if (value === ALL_DAY || value === 0 || R.isEmpty(value))
        return (payload[key] = null)
    })
    delete payload.selectedRetry

    effects.apis
      .updateAutomatedCallSetting({
        placeId: place.id,
        data: payload,
      })
      .then(() => {
        onSuccess()
        dispatchs(
          MessageAlert.showSuccess({
            message: formatMessage({
              id: 'crm.successSaved',
            }),
          }),
        )
      })
      .catch((error) => {
        dispatchs(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }

  const times = [
    {
      label: formatMessage({
        id: 'manageChannels.selectorTime.allDay.lable',
      }),
      value: ALL_DAY,
    },
    ...Array(24)
      .fill(1)
      .map((val, i) => {
        return {
          label: `${normalizeTime(i)}:00`,
          value: `${normalizeTime(i)}:00:00`,
        }
      })
      .flat(),
  ]

  return {
    times,
    submit,
    validationForm,
  }
}
